<template>
  <div>
    <!-- 内容区 -->
    <div class="about myCenter bg-blue">
      <!-- banner -->
      <div class="banner-home banner-small"></div>

      <div class="container">
        <div class="about-list">
          <a class="list-group-item active">申报书</a>
          <a class="list-group-item" @click="donwloadFile">下载报名表</a>
        </div>
        <div class="content-box">
          <div class="success-tip" hidden>
            <img src="../assets/images/img-success.png" />
            <h4>申报书提交成功</h4>
            <button
              class="btn btn-primary btn-round btn-lg"
              data-toggle="modal"
              data-target="#modal-review"
            >
              查看申报书
            </button>
            <a href="#">修改申报书</a>
          </div>
          <h4 class="text-center">
            保护个人信息 护航数据安全<br />{{opusName}}案例申报书
          </h4>
          <form @submit.prevent="validateForm">
            <!-- 申报对象 -->
            <div class="form-group" v-if="formData.opus_type!=1">
              <label>申报对象<span>*</span></label>
              <div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    id="apply_type_company"
                    value=1
                    v-model="formData.apply_type"
                    class="custom-control-input"
                  />
                  <label class="custom-control-label" for="apply_type_company"
                    >单位申报</label
                  >
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    id="apply_type_single"
                    value=2
                    v-model="formData.apply_type"
                    class="custom-control-input"
                  />
                  <label class="custom-control-label" for="apply_type_single"
                    >个人申报</label
                  >
                </div>
              </div>
            </div>
            <!-- 单位信息 -->
            <div class="form-group" v-if="formData.apply_type==1">
              <label>申报单位<span>*</span></label>
              <input
                type="text"
                :class="{'form-control': true, 'is-invalid': errors.has('company')}"
                placeholder="请输入申报单位"
                v-model="formData.company"
                name="company"
                v-validate="'required'"
              />
              <div class="invalid-feedback">
                请输入单位名称
              </div>
            </div>
            <!-- 注册地址 -->
            <label v-if="formData.apply_type==1"
              >注册地址<span
                >*
                <small
                  >(非河北企业，请在资料中说明项目在河北落地情况)</small
                ></span
              ></label
            >
            <!-- 省市区 -->
            <div class="form-row" v-if="formData.apply_type==1">
              <div class="form-group col-md-2">
                <select :class="{'form-control': true, 'is-invalid': errors.has('province')}" v-validate="'required'" name="province" v-model="formData.province">
                  <option>选择省</option>
                  <option>2</option>
                </select>
                <div class="invalid-feedback">
                  请填写注册地址
                </div>
              </div>
              <div class="form-group col-md-2">
                <select :class="{'form-control': true, 'is-invalid': errors.has('city')}" v-validate="'required'" name="city" v-model="formData.city">
                  <option>选择市</option>
                  <option>2</option>
                </select>
              </div>
              <div class="form-group col-md-2">
                <select :class="{'form-control': true, 'is-invalid': errors.has('district')}" v-validate="'required'" name="district" v-model="formData.district">
                  <option>选择区</option>
                  <option>2</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <input type="text" :class="{'form-control': true, 'is-invalid': errors.has('address')}" v-validate="'required'" name="address" />
              </div>
            </div>
            <!-- 个人信息 -->
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>联系人<span>*</span></label>
                <input
                  type="text"
                  :class="{'form-control': true, 'is-invalid': errors.has('contact_name')}" v-validate="'required'" name="contact_name"
                  placeholder="请输入联系人真实姓名"
                  v-model="formData.contact_name"
                />
              </div>
              <div class="form-group col-md-6">
                <label>联系人职务<span>*</span></label>
                <input
                  type="text"
                  :class="{'form-control': true, 'is-invalid': errors.has('contact_position')}" v-validate="'required'" name="contact_position"
                  placeholder="请输入联系人职务"
                  v-model="formData.contact_position"
                />
              </div>

              <div class="form-group col-md-6">
                <label>联系电话<span>*</span></label>
                <input
                  type="text"
                  :class="{'form-control': true, 'is-invalid': errors.has('contact_mobile')}" v-validate="'required'" name="contact_mobile"
                  placeholder="请输入联系电话"
                  v-model="formData.contact_mobile"
                  
                />
              </div>
              <div class="form-group col-md-6">
                <label for="inputState">联系邮箱<span>*</span></label>
                <input
                  type="text"
                  :class="{'form-control': true, 'is-invalid': errors.has('contact_email')}" v-validate="'required|email'" name="contact_email"
                  placeholder="请输入联系邮箱"
                  v-model="formData.contact_email"
                />
              </div>
            </div>
            <hr />
            <div class="form-group">
              <label>案例名称<span>*</span></label>
              <input
                type="text"
                :class="{'form-control': true, 'is-invalid': errors.has('opus_name')}" v-validate="'required'" name="opus_name"
                placeholder="请输入案例名称"
                v-model="formData.opus_name"
              />
            </div>
            <!-- 应用场景 -->
            <div class="form-group" v-if="formData.opus_type==1">
              <label>应用场景<span>*</span></label>
              <input
                type="text"
                :class="{'form-control': true, 'is-invalid': errors.has('opus_scene')}" v-validate="'required'" name="opus_scene"
                placeholder="如：电子政务、电子商务、人工智能、云计算、大数据、物联网、工业互联网、互联网医疗、互联网金融等"
                v-model="formData.opus_scene"
              />
            </div>
            <!-- 应用环节 -->
            <div class="form-group" v-if="formData.opus_type==1">
              <label>应用环节<span>*</span></label>
              <input
                type="text"
                :class="{'form-control': true, 'is-invalid': errors.has('opus_chain')}" v-validate="'required'" name="opus_chain"
                placeholder="如：数据收集、存储传输、使用销毁、交换公开等"
                v-model="formData.opus_chain"
              />
            </div>
            <!-- 实践形式 -->
            <div class="form-group" v-if="formData.opus_type==1">
              <label>实践形式<span>*</span></label>
              <input
                type="text"
                :class="{'form-control': true, 'is-invalid': errors.has('opus_practice')}" v-validate="'required'" name="opus_practice"
                placeholder="如：解决方案、技术应用、服务标准、流程理念等"
                v-model="formData.opus_practice"
              />
            </div>
            <!-- 应用实践 -->
            <div class="form-group" v-if="formData.opus_type==1">
              <label>案例应用时间<span>*</span></label>
              <input
                type="text"
                :class="{'form-control': true, 'is-invalid': errors.has('opus_launch_time')}" v-validate="'required'" name="opus_launch_time"
                placeholder="请输入案例应用时间, 如：2020-01-01"
                v-model="formData.opus_launch_time"
              />
            </div>
            <!-- 主要情况 -->
            <div class="form-group">
              <label>案例主要情况<span>*</span></label>
              <textarea
                rows="8"
                :class="{'form-control': true, 'is-invalid': errors.has('opus_main')}" v-validate="'required'" name="opus_main"
                v-model="formData.opus_main"
                placeholder="情况简介。详细材料可作为附件，1000字以内，应至少包含应用情况、创新性、实用性、可推广性等角度，着重写明应用系统或平台使用情况、实际成效、设计理念，请连同纸质申报书一同邮寄。"
              />
            </div>
            <!-- 案例效果 -->
            <div class="form-group">
              <label>案例取得效果<span>*</span></label>
              <textarea
                rows="4"
                :class="{'form-control': true, 'is-invalid': errors.has('opus_effect')}" v-validate="'required'" name="opus_effect"
                placeholder="效果简介。详细材料可作为附件，500字以内, 请连同纸质申报书一同邮寄。"
                v-model="formData.opus_effect"
              />
            </div>
            <!-- 其他材料 -->
            <div class="form-group">
              <label>其他材料<span>*</span></label>
              <textarea
                rows="8"
                :class="{'form-control': true, 'is-invalid': errors.has('opus_other')}"
                v-model="formData.opus_other"
                v-validate="'required'"
                name="opus_other"
                placeholder="其他情况简介。详细材料可作为附件，500字以内。其他资料包括能够体现案例价值的情况，如获奖、专家推荐、公开报道等，及其证明材料的原件或复印件，请连同纸质申报书一同邮寄。"
              />
            </div>
            <div class="form-group text-center">
              <button type="submit" class="btn btn-primary btn-round btn-lg">
                确认提交
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- 提示弹出 -->
    <div
      class="modal fade modal-intro modal-review"
      id="modal-review"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <a class="modal-close" data-dismiss="modal" aria-label="Close">
            <i class="iconfont icon-close"></i>
          </a>
          <div class="modal-body">
            dddd
          </div>
         
         
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {submitForm} from "@/network/API.js";
export default {
  data() {
    return {
      opusType: 1,
      opusName: "实践类",
      formData: {
        opus_type: 1,
        apply_type: 1,
        company: "",
        province: "",
        city: "",
        district: "",
        address: "",
        contact_name: "",
        contact_position: "",
        contact_mobile: "",
        contact_email: "",
        opus_name: "",
        opus_scene: "",
        opus_chain: "",
        opus_practice: "",
        opus_launch_time: "",
        opus_intro: "",
        opus_effect: "",
        opus_main: "",
        opus_other: ""
      }
    };
  },
  created() {
    console.log("type is ", this.$route.params.type);
    if (this.$route.params.type) {
      this.formData.opus_type = this.$route.params.type;
      switch (this.formData.opus_type) {
        case 1:
          this.opusName = "实践类";
          break;
        case 2:
          this.opusName = "理论类";
          break;
        case 3:
          this.opusName = "宣传类";
          break;
        default:
          break;
      }
    }
  },
  methods: {
    donwloadFile() {
      this.$store.commit("setToken", "");
    },
    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.submitForm()
          return;
        }
      });
    },
    async submitForm() {
      console.log(JSON.stringify(this.formData));
      // let res = await submitForm(this.formData)
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/myCenter.vue